﻿import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

declare var alertify: any
alertify.set('notifier', 'position', 'top-right');

/**
 * Provides signin method to signin & signup components.
 */
export class Signin {
    model: any = {};

    errorMessage: string = "";

    constructor(public router: Router, public authenticationService: AuthenticationService) { }
    
    userIsActive(): void {
        this.authenticationService.isUserActive(this.model.username).subscribe(() => {
           this.signin();
        }, 
        (error: any) => {
            if(error.status === 401) {
                let errMsg = "Bruger er ikke aktiv";
                alertify.notify(errMsg, 'error', 4, function () { });
            }
            if(error.status === 404) {
                  let errMsg = "Ugyldigt brugernavn eller kodeord";
                        alertify.notify(errMsg, 'error', 4, function () { });
            }
        });
    }
    

   signin(): void {
        this.authenticationService.signin(this.model.username, this.model.password)
            .subscribe(
            () => {
                // Optional strategy for refresh token through a scheduler.
                this.authenticationService.scheduleRefresh();

                // Gets the redirect URL from authentication service.
                // If no redirect has been set, uses the default.
                if (this.authenticationService.userSubject.value.role != null || this.authenticationService.userSubject.value.role != undefined || this.authenticationService.userSubject.value.role === undefined || this.authenticationService.userSubject.value.role === null) {
                    let WaitToSetUserAndRedirect = setTimeout(() => {
                        if (this.authenticationService.userSubject.value.role === 'overblik') {
                            // Redirects the user.
                            let redirect: string = this.authenticationService.redirectUrl
                                ? this.authenticationService.redirectUrl
                                : '/dashboard';
                            this.router.navigate([redirect]);
                            let msg = "Velkommen " + this.model.username;
                            alertify.notify(msg, 'success', 4, function () { });
                            clearTimeout(WaitToSetUserAndRedirect);
                        } else {
                            let redirect: string = this.authenticationService.redirectUrl
                                ? this.authenticationService.redirectUrl
                                : '/entry';
                            this.router.navigate([redirect]);
                            let msg = "Velkommen " + this.model.username;
                            alertify.notify(msg, 'success', 3, function () { });
                            clearTimeout(WaitToSetUserAndRedirect);
                        }
                    }, 1000);
                }
            },
            (error: any) => {
                // Checks for error in response (error from the Token endpoint).
                if (error.body != "") {
                    let body: any = error.json();

                    switch (body.error) {
                        case "invalid_grant":
                            this.errorMessage = "Ugyldigt brugernavn eller kodeord";
                            alertify.notify(this.errorMessage, 'error', 4, function () { });
                            break;
                        default:
                            this.errorMessage = "Uventet fejl. Prøv igen";
                            alertify.notify(this.errorMessage, 'error', 4, function () { });
                    }
                } else {
                    let errMsg = (error.message) ? error.message :
                        error.status ? `${error.status} - ${error.statusText}` : 'Server fejl';
                    console.log(errMsg);
                    this.errorMessage = "Server fejl. Kontakt leverandør.";
                    alertify.notify(this.errorMessage, 'error', 4, function () { });
                }
            });
    }

    signout(): void {
        let msg = "Logget ud";
        alertify.notify(msg, 'success', 4, function () { });

        this.authenticationService.signout();


    }
}
